/*!

=========================================================
* Vue White Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vue-white-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/vue-white-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import VueRouter from "vue-router";
import SocialSharing from "vue-social-sharing";
import VueGitHubButtons from "vue-github-buttons";
import "vue-github-buttons/dist/vue-github-buttons.css";
import App from "./App.vue";
import "@/assets/scss/white-dashboard.scss";
import "@/assets/css/nucleo-icons.css";
import "@/assets/demo/demo.css";

import GlobalComponents from "./globalComponents";
import globalVariable from "./globalVariable";
import GlobalDirectives from "./globalDirectives";
import RTLPlugin from "./RTLPlugin";
import Notify from "@/components/NotificationPlugin";
import i18n from "./i18n";
import SideBar from "@/components/SidebarPlugin";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueTheMask from "vue-the-mask";
import VueGeolocation from "vue-browser-geolocation";
import Axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import VueAutosuggest from "vue-autosuggest";
import VueHtmlToPaper from "vue-html-to-paper";
import jwt from "jsonwebtoken";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";

// element ui language configuration
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);

const baseURL = process.env.VUE_APP_ADDRESS;

Vue.config.productionTip = false;
Axios.defaults.baseURL = process.env.VUE_APP_API_ADDRESS;

//print options
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    `${baseURL}assets/css/print.css`,
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
};

// router setup
import routes from "./router";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "active",
});

router.beforeEach((nextPage, beforePage, next) => {
  // const token = getCookie("token")
  const w_ = getCookie("w_");
  var validToken = false;
  var lvlAccess = 0;

  jwt.verify(w_, globalVariable.KEY_LEVEL_1, function(err, decoded) {
    if (decoded) {
      lvlAccess = 1;
    }
  });

  jwt.verify(w_, globalVariable.KEY_LEVEL_3, function(err, decoded) {
    if (decoded) {
      lvlAccess = 3;
    }
  });

  jwt.verify(w_, globalVariable.KEY_LEVEL_5, function(err, decoded) {
    if (decoded) {
      lvlAccess = 5;
    }
  });

  jwt.verify(w_, globalVariable.KEY_LEVEL_7, function(err, decoded) {
    if (decoded) {
      lvlAccess = 7;
    }
  });

  jwt.verify(w_, globalVariable.KEY_LEVEL_10, function(err, decoded) {
    if (decoded) {
      lvlAccess = 10;
    }
  });

  if (lvlAccess > 0) {
    validToken = true;
  } else {
    validToken = false;
  }

  if (!validToken && !nextPage.meta.public) {
    deleteAllCookies();
    next({ name: "login" });
  } else {
    if (nextPage.meta.levelAccess >= lvlAccess) {
      next();
    } else {
      next({ name: beforePage.name });
    }
  }
});

function getCookie(name) {
  var cookies = document.cookie;
  var prefix = name + "=";
  var begin = cookies.indexOf("; " + prefix);

  if (begin == -1) {
    begin = cookies.indexOf(prefix);
    if (begin != 0) {
      return null;
    }
  } else {
    begin += 2;
  }

  var end = cookies.indexOf(";", begin);
  if (end == -1) {
    end = cookies.length;
  }

  return unescape(cookies.substring(begin + prefix.length, end));
}

function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

Vue.use(VueHtmlToPaper, options);
Vue.use(Element);
Vue.use(VueRouter);
Vue.use(SocialSharing);
Vue.use(VueGitHubButtons, { useCache: true });
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(RTLPlugin);
Vue.use(SideBar);
Vue.use(Notify);
Vue.use(VueTheMask);
Vue.use(VueGeolocation);
Vue.use(VueAxios, Axios);
Vue.use(VueAutosuggest);
Vue.use(VueCookies);
Vue.use(Autocomplete);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
